// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R8vk","type":"styles_type__3S5gH","choices":"styles_choices__2QArr"};